import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { Languages, ListSection, Section, StructuredListSection } from 'common';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { FPCard, FPCardContent, FPCardHeader } from 'UI/components/atoms/FPCard';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { EntityType } from 'UI/constants/entityTypes';
import { isTruthyValue } from 'utils';

import { LoaderContainer } from './DataSheetPreview.styled';

const COPIES = strings.inventoryProfiles.sections.tabs.dataSheet;

const buildTitleAndSubtitleByEntityType = (entityType, data) => {
  if (entityType === EntityType.Contact) {
    const contactData = data?.contact;
    return { title: contactData?.name || '', subtitle: contactData?.title || '' };
  }

  const contactData = data?.[entityType];
  return { title: contactData?.name || '', subtitle: contactData?.title || '' };
};

export const DataSheetPreview = ({
  apiInstance,
  endpoint,
  entityType,
  formatResponse,
  profileId
}) => {
  const { Status, state } = useFetchWithStatusV2({
    apiInstance,
    endpoint: endpoint ? endpoint.replace(':id', profileId) : null
  });

  const results = state?.results;
  const { title, subtitle } = buildTitleAndSubtitleByEntityType(entityType, results);
  const formattedData = formatResponse(results?.data);
  const { candidateBackground, professionalInsights } = formattedData || {};
  const { educationItems, employmentHistoryItems, licensesAndCertificationsItems } =
    candidateBackground || {};

  const { achievements, experienceSummary, languages, skills } = professionalInsights || {};

  return (
    <Status
      loading={
        <LoaderContainer>
          <CircularProgress />
        </LoaderContainer>
      }
      success={() => (
        <FPCard>
          <FPCardHeader title={title} subheader={subtitle} />
          <FPCardContent>
            {isTruthyValue(experienceSummary) && (
              <Section title={COPIES.sections.experienceSummary}>
                <Typography variant="body1">{experienceSummary}</Typography>
              </Section>
            )}
            <StructuredListSection
              title={COPIES.sections.experience.title}
              items={employmentHistoryItems}
            />
            <StructuredListSection title={COPIES.sections.education.title} items={educationItems} />
            <StructuredListSection
              title={COPIES.sections.licensesAndCertifications}
              items={licensesAndCertificationsItems}
            />

            {isTruthyValue(achievements?.achievement) && (
              <Section title={COPIES.sections.achievements}>
                <Typography variant="body1">{achievements.achievement}</Typography>
              </Section>
            )}

            <Languages languages={languages} />

            <ListSection title={COPIES.sections.skills} items={skills} />
          </FPCardContent>
        </FPCard>
      )}
      error={() => <EmptyPlaceholder title={COPIES.emptyState} />}
      empty={<EmptyPlaceholder title={COPIES.emptyState} />}
    />
  );
};
